module.exports = __webpack_public_path__ + "img/140ne.8319f437.svg";